import React from "react";

/**
 * Convert signature string to image
 *
 * @param signature
 * @return {null|*}
 */
export const renderSignature = (signature) => {
    if (signature) {
        return (
            <img src={`data:image/jpeg;base64,${signature}`} alt="Signature"/>
        );
    }
    return null
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/imageFunctions.js